import {Component, OnInit, Input, ViewEncapsulation, OnDestroy} from '@angular/core';
import { ThingToggleEvent } from '../../../events/things/ThingToggleEvent';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: 'things-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.less']
})

export class ThingsToggleComponent implements OnInit, OnDestroy {

  @Input()
  public areas: Array<any> = [];

  @Input()
  public selectedAreas: Array<any> = [];

  public open: boolean = false;
  public showHeaderBottomLine: boolean = false;

  private thingToggleSubscription: Subscription;

  constructor(private thingToggle: ThingToggleEvent, public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.areas.map(area => {
      area.selected = this.selectedAreas.indexOf(area.areaId) > -1 || area.selected;
    });

    this.thingToggleSubscription = this.thingToggle.on().subscribe(data => {
      const key = data.key;

      if (key === 'thingsToggle.open') {
        const areas = data.areas;
        const selectedAreas = data.selectedAreas;

        areas.map(area => {
          if (selectedAreas.indexOf(area.areaId) > -1 || area.selected) {
            area.selected = true;
          } else {
            area.selected = false;
          }
        });

        this.areas = areas;

        this.open = true;
      }
    });
  }

  ngOnDestroy(){
    if (this.thingToggleSubscription)
      this.thingToggleSubscription.unsubscribe();
  }

  reset($event){
    $event.preventDefault();
    $event.stopPropagation();

    this.areas.map(area => {
      area.selected = this.selectedAreas.indexOf(area.areaId) > -1;
    });
  }

  isOpen() {
    return this.open;
  }

  close() {
    this.open = false;

    this.activeModal.dismiss('Close click');
  }

  save() {
    if (! this.isOneSelected()) {
      return;
    }

    this.thingToggle.fire('thingsToggle.save', this.areas, []);
    this.close();
  }

  toggleSelected(area) {
    area.selected = ! area.selected;
  }

  toggleAll($event) {
    $event.preventDefault();
    $event.stopPropagation();

    let numSelected = this.areas.filter(area => area.selected).length;
    if (numSelected > 0) {
      this.areas.map(area => {
        area.selected = false;
      });
    } else {
      this.areas.map(area => {
        area.selected = true;
      });
    }
  }

  isOneSelected() {
    return this.areas.filter(area => area.selected).length > 0;
  }

  getSelectedAreasNumber() {
    return this.areas
      .filter(area => area.selected)
      .length;
  }

  onContentScroll(scrollTop) {
    this.showHeaderBottomLine = (scrollTop > 0);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/components/things/toggle/toggle.component.ts